module.exports = __webpack_public_path__ + "static/media/Hero_Image_Mobile.a8f6066c.jpg";